import { localNow } from "@/shared/local-now";
import { z } from "zod/v4";
import CompraGeneralInfoFields from "./_shared/compra-general-info-fields";
import CompraArticuloSearch from "./_shared/compra-articulo-search";
import { Stack, Grid2 as Grid } from "@mui/material";
import CompraArticuloList from "./_shared/compra-articulo-list";
import { Form, FormApi, FormProps } from "@/components/form";

export const compraFormSchema = z.object({
    proveedorId: z.string().nonempty("Este campo es requerido"),
    numComprobante: z.string().nonempty("Este campo es requerido"),
    depositoId: z.string().optional(),
    fecha: z.iso.datetime({ local: true, message: "Este campo es requerido" }).default(localNow()),
    credito: z.boolean(),
    items: z.array(z.object({
        articuloId: z.string().nonempty("Este campo es requerido"),
        cantidad: z.number().min(1, "La cantidad debe ser mayor que 0"),
        costoUnitario: z.number().gt(0, "El costo debe ser mayor que 0")
    })).min(1, "Debe haber por lo menos un ítem")
})

interface CompraFormProps extends FormProps<z.input<typeof compraFormSchema>> {
    onCancel?: (form: FormApi) => void
}

export default function CompraForm({
    onCancel,
    form,
    ...props
}: CompraFormProps) {
    return <Form form={form} gap={3} {...props}>
        <CompraGeneralInfoFields />
        <Grid container columns={{ xs: 1, md: 3 }} spacing={5} flex={1}>
            <Grid component={Stack} size={1}>
                <CompraArticuloSearch
                    onArticuloSelect={value => form.pushFieldValue("items", {
                        articuloId: value.articulo.id,
                        articulo: value.articulo,
                        costoUnitario: value.costo,
                        cantidad: value.cantidad
                    } as any)}
                />
            </Grid>
            <Grid component={Stack} size={2} gap={3}>
                <form.Field name="items" mode="array">
                    {field => <CompraArticuloList
                        items={field.state.value}
                        remove={field.removeValue}
                    />}
                </form.Field>
                <Stack direction={"row"} justifyContent={"end"} gap={3}>
                    <Form.Button onClick={() => onCancel && onCancel(form)}>Cancelar</Form.Button>
                    <Form.SubmitButton>Guardar</Form.SubmitButton>
                </Stack>
            </Grid>
        </Grid>
    </Form>
}